export const durationMap:any = [
    { label: '15 Days Trial' , value: 15 },
    { label: '30 Days Trial'  , value: 30 },
    { label: '45 Days Trial'  , value: 45 },
    { label: '60 Days Trial'  , value: 60 },
    { label: '1 Year Course'  , value: 365 },
    { label: '2 Years Course'  , value: 730 },
    { label: '3 Years Course'  , value: 1095 },
    { label: '4 Years Course'  , value: 1460 },
    { label: '5 Years Course'  , value: 1825 },
    { label: '6 Years Course'  , value: 2190 }
]

export const getCourseDurationByDate = (startDate: string, endDate: string) => {
    
    let courseDuration;

    const packageStartDate = new Date(startDate);
    const packageEndDate = new Date(endDate);

    const differenceInTime = Math.abs(packageStartDate.getTime() - packageEndDate.getTime());

    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
    
    let durationIndex;
    // durationMap.forEach((duration: any, index: number) => {
    //     if(differenceInDays > +Object.keys(duration)[0])
    //         durationIndex = index;
    // })

    let differenceCount = []
    for(let i = 0; i < durationMap.length; i++){
        if(differenceInDays >= durationMap[i].value)
            {
                differenceCount.push({difference: durationMap[i].value - differenceInDays, index: i})
            } 
    }

    if(differenceCount.length === 0) {
        differenceCount.push({difference: 15, index: 0})
    }

    if(differenceCount.length === 0) {
        differenceCount.push({difference: 15, index: 0})
    }

    let smallestDifference = differenceCount[0];
    
    differenceCount.forEach((diff:any, index) => {
        if(diff !== smallestDifference){
            if( Math.abs(diff.difference) < Math.abs(smallestDifference.difference))
            smallestDifference = diff;
        }
    })
    durationIndex = smallestDifference && smallestDifference.index;

    const firstDuration = durationMap[durationIndex];
    let nextDuration;
    if(durationIndex) {
            if(durationIndex < (durationMap.length - 1)) {
                nextDuration = durationMap[durationIndex + 1];
            }
    }

    const differenceWithFirstDuration = firstDuration && (differenceInDays - firstDuration.value)
    let differenceWithNextDuration;
    if(nextDuration) {
        differenceWithNextDuration = nextDuration && ( nextDuration.value - differenceInDays)
    }

    if(differenceWithNextDuration ) {
        if(differenceWithNextDuration < differenceWithFirstDuration) {
            courseDuration = nextDuration && nextDuration.value
        } else {
            courseDuration = firstDuration && firstDuration.value
        }
    } else {
        courseDuration = firstDuration && firstDuration.value // TODO: Sending number now, check date change
    }
    
    
    return courseDuration;
}


export const getCourseDurationLabel = (details: any) => {
    console.log(details);
    const { duration } = details;
    let courseLabel = 'NA';
    if(duration > 0) {
        for(let i = 0; i < durationMap.length; i++){
            if(durationMap[i].value === duration){
                courseLabel = durationMap[i].label;
                break; 
            }
        }
    }
    

    return courseLabel;
}
